module.exports = __webpack_public_path__ + "img/Chevron Down.4e144b48.svg";